import * as React from "react";
import { Form, Tab, Table, Icon, TabPane, TableBody, TableCell, TableRow, FormButton, TableHeader, TableHeaderCell, FormField, FormInput, FormDropdown, FormGroup, FormCheckbox, FormTextArea } from "@/components/bp/bp-ui";
import { IDropdownItem } from "../IDropdownItem";
import { FormErrorList } from "../FormErrorList";
import { TimeZonePicker } from "../TimeZonePicker";
import { CSS } from "@dnd-kit/utilities";
// import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import {
    DndContext,
    KeyboardSensor,
    useSensor,
    useSensors,
    MouseSensor,
    TouchSensor,
    DragEndEvent,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { TranslationContext } from "../Contexts/TranslationContext";
import { AlleleFormat, LabClient, LabEditFullModel, LabPopulationModel, ParameterTypes, RunParameterModel, RunTypeModel, SharingSampleType, TranslationClient } from "@app/api2/api";
import { LabAgenciesViewFC } from "./LabAgenciesView";
import { LabPrintingOptions } from "./LabPrintingOptions";
import { ReportTextTemplate } from "./ReportTextTemplate";
import { toAlleleFormatName, toSharingSampleTypeName } from "@common/AlleleFormatNames";
import { HandlerRegistry } from "../CaseRun/RunTypes/HandlerRegistry";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { BPCheckbox } from "@/components/bp/bpcheckbox";
import { BPContainer } from "@/components/bp/bpcontainer";

class LabEditFormValues {
    name: string = "";
    timeZone: string = "";
}

class LabEditState {
    public localeList: Array<IDropdownItem<string>>;
    public timeZoneList: any[];
    public renderedTimeZoneList: Array<IDropdownItem<string>>;
    public loading: boolean = true;
    public showServerErrors: boolean;
    public serverErrors: string[];
    public timeZoneSearch: string;
    public currentMainTab: number;
    public currentParameterTab: number;
    public lab: LabEditFullModel;

}



// const DragHandle = SortableHandle(() => <Icon name="content" />);

function DragHandle(props) {
    // const { attributes, listeners, setNodeRef } = useDraggable({
    //     id: 'unique-id',
    // });

    return (
        <Icon name="content" {...props} />
    );
}

const PopulationList = (({ items, onSortEnd, onPopulationCheckChange }: { items: LabPopulationModel[], onSortEnd: (e: DragEndEvent) => void, onPopulationCheckChange: (e: {populationId: number, checked: boolean}) => void }) => {
    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    );

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event;
        if (active.id !== over.id) {
            onSortEnd(event);
            // setData((data) => {
            //     const oldIndex = items.indexOf(active.id);
            //     const newIndex = items.indexOf(over.id);
            //     return arrayMove(data, oldIndex, newIndex);
            // });
        }

        // setActiveId(null);
    }


    return (
        <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
            <TableBody>

                <SortableContext items={items.map(i => i.populationId)} strategy={verticalListSortingStrategy} >
                    {items.map((value, index) => (<PopulationListItem key={value.populationId} value={value} index={index} handlePopulationCheckChange={onPopulationCheckChange} />))}
                </SortableContext>
            </TableBody>

        </DndContext>
    );
});

const PopulationListItem = (({ value, index: number, handlePopulationCheckChange }: { value: LabPopulationModel, index: number, handlePopulationCheckChange: (e: {populationId: number, checked: boolean}) => void }) => {
    const {
        attributes,
        listeners,
        transform,
        transition,
        setNodeRef,
        isDragging
    } = useSortable({
        id: value.populationId
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition: transition
    };
    return (<TableRow ref={setNodeRef} style={style}>
        {/* {isDragging && <td colSpan={2}></td>}
        {!isDragging && <> */}
        <TableCell><DragHandle {...attributes} {...listeners} />{value.populationName}</TableCell>
        <TableCell><BPCheckbox checked={value.enabled} onChange={(e, a) => handlePopulationCheckChange({populationId: value.populationId, checked: a.checked})} /></TableCell>
        {/* </>} */}
    </TableRow>);
});

interface ILabEditProps {
    labId: number;
    // baseUrl: string;
    //translation: ClientResources;
}

export class LabEdit extends React.Component<ILabEditProps, LabEditState> {

    private labClient = new LabClient();
    private translationClient = new TranslationClient();

    constructor(props, context) {
        super(props, context);

        this.state = new LabEditState();
    }

    public async componentDidMount(): Promise<any> {
        const lab = await this.labClient.get(this.props.labId);
        const locales = await this.translationClient.getLocales();

        if (!lab.locale) {
            lab.locale = locales.find((l) => (l.siteDefault)).code;
        }

        this.setState({
            localeList: locales.map((l) => ({ key: l.code, value: l.code, text: l.name })),
            lab: lab,
            loading: false
        });
    }

    public render() {
        const updateMainTab = (e, { activeIndex }) => {
            this.setState({ currentMainTab: activeIndex });
        };

        const mainTabs = [
            { path: '/', menuItem: window.translation.lab.labInformation, render: () => this.renderLabInfoPanel() },
            { path: '/kits', menuItem: window.translation.common.kits, render: () => this.renderKitsPanel() },
            { path: '/populations', menuItem: window.translation.common.populations, render: () => this.renderPopulationPanel() },
            { path: '/parameters', menuItem: window.translation.common.parameters, render: () => this.renderParametersPanel() },
            { path: '/agencies', menuItem: window.translation.lab.agencies, render: () => this.renderAgenciesPanel() },
            { path: '/report-text', menuItem: window.translation.reportTexts.reportTextTemplate, render: () => this.renderReportText() },
            { path: '/print-options', menuItem: window.translation.lab.casePrintOptions, render: () => this.renderPrintOptions() },
        ];

        return (<TranslationContext.Consumer>{t =>
        (<BPContainer>

            {!this.state.loading &&
                <><div className="ui secondary menu">
                    <div className="header item">
                        <h2>Detail for Lab {this.state.lab.name}</h2>
                    </div>
                    <div className="right menu">
                        <div className="right item">
                            <FormButton onClick={this.handleSave}>{t.common.save}</FormButton>
                        </div>
                    </div>
                </div>
                    <Form loading={this.state.loading}>
                        <Tab menu={{ vertical: true, tabular: true }} panes={mainTabs} onTabChange={updateMainTab}
                            activeIndex={this.state.currentMainTab}>
                        </Tab>
                        <FormErrorList message="There was an error updating the lab" show={this.state.showServerErrors}
                            errors={this.state.serverErrors} />
                    </Form></>
            }
        </BPContainer>)}</TranslationContext.Consumer>);
    }

    private submit = () => {

    };


    private handleInputChange = (event: React.ChangeEvent<any>, data) => {
        const target = event.target;
        const name = data.name;
        let value: any;
        if (name == 'defaultAlleleFormats') {
            const format = (event.target.id as string).replace('ch_', '')

            if (data.checked)
                value = [...this.state.lab.defaultAlleleFormats, format]
            else
                value = this.state.lab.defaultAlleleFormats.filter(x => x != format as any)
        }
        if (name == 'sharedSampleTypes') {
            const format = (event.target.id as string).replace('sh_', '')

            if (data.checked)
                value = [...this.state.lab.sharedSampleTypes, format]
            else
                value = this.state.lab.sharedSampleTypes.filter(x => x != format as any)
        }
        else if (data.type === "checkbox") {
            value = data.checked;
        } else {
            value = data.value;
        }
        this.setState({ lab: { ...this.state.lab, [name]: value, } });
    };


    private handleKitCheckChange = (e, args) => {
        const kits = this.state.lab.kits;

        kits[args.index].enabled = args.checked;
        this.setState({ lab: { ...this.state.lab, kits: kits, } });

    };

    private handlePopulationCheckChange = ({populationId, checked}) => {
        const popIndex = this.state.lab.populations.findIndex((k) => k.populationId === populationId);
        const populations = this.state.lab.populations;
        populations[popIndex].enabled = checked;
        this.setState({ ...this.state, lab: { ...this.state.lab, populations: populations } });
        //this.setState(Update(this.state, { lab: { populations: { $splice: [[popIndex, 1, args.population]] } } }));
    };

    private handleSave = async (): Promise<any> => {

        // console.log(this.state.lab)

        const result = await this.labClient.update(this.props.labId, this.state.lab)

        if (result.success) {
            window.location.assign(buildUrl(AppRoutes.LabDetails, { labId: this.props.labId }));
        } else {
            this.setState(
                {
                    loading: false,
                    showServerErrors: true,
                    serverErrors: result.errors
                });
        }

    };

    private handlePopulationSort = (e: DragEndEvent) => {
        // console.log(e);
        let pops = this.state.lab.populations;
        const oldIndex = pops.findIndex((pop) => pop.populationId === e.active.id);
        const newIndex = pops.findIndex((pop) => pop.populationId === e.over.id);
        const oldItem = pops[oldIndex];
        const newItem = pops[newIndex];


        const oldOrder = oldItem.order;
        oldItem.order = newItem.order;
        newItem.order = oldOrder;

        pops = arrayMove(pops, oldIndex, newIndex);

        // pops = pops.sort((a, b) => a.order - b.order);
        this.setState({ lab: { ...this.state.lab, populations: pops } });
        // console.log(e);
    };

    private renderKitsPanel() {
        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.kit.name}</TableHeaderCell>
                            <TableHeaderCell>{t.common.enabledQuestion}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.state.lab.kits.map((k, i) => {
                            return (
                                <TableRow key={k.kitId}>
                                    <TableCell>{k.fullName}</TableCell>
                                    <TableCell><BPCheckbox checked={k.enabled}
                                        onChange={(e, a) => this.handleKitCheckChange(e, {
                                            ...a,
                                            kit: k,
                                            index: i
                                        })} /></TableCell>
                                </TableRow>);
                        })}
                    </TableBody>
                </Table>
            </TabPane>}</TranslationContext.Consumer>);
    }

    // private PopulationListItem = SortableElement(({ value }) => {
    //     return (<Table.Row>
    //         <Table.Cell><DragHandle />{value.populationName}</Table.Cell>
    //         <Table.Cell><BPCheckbox checked={value.enabled} onChange={(e, a) => this.handlePopulationCheckChange(e,
    //             {
    //                 ...a,
    //                 population: value
    //             })} /></Table.Cell>
    //     </Table.Row>);
    // });


    // private PopulationList = SortableContainer(({ items }) => {
    //     return (<Table.Body>
    //         {items.map((value, index) => (<this.PopulationListItem key={value.populationId} value={value} index={index} />))}
    //     </Table.Body>);
    // });



    private renderPopulationPanel() {

        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.population.name}</TableHeaderCell>
                            <TableHeaderCell>{t.common.enabledQuestion}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <PopulationList items={this.state.lab.populations} onSortEnd={this.handlePopulationSort} onPopulationCheckChange={this.handlePopulationCheckChange} 
                    />
                </Table>

            </TabPane>}</TranslationContext.Consumer>
        );
    }

    private renderParametersTab = (runType: RunTypeModel, index: number) => {
        const onChange = (m: RunParameterModel, i: number, v: string | boolean) => {
            const lab = { ...this.state.lab };
            const runTypes = lab.runTypes;
            if (m.parameterType == ParameterTypes.Boolean || typeof v == 'boolean') {
                runTypes[index].parameters[i].defaultValue = v ? "1" : "0";
            }
            else {
                runTypes[index].parameters[i].defaultValue = v;
            }

            this.setState({ lab: lab });
        };

        const runtypeHandler = HandlerRegistry.getRunTypeHandler(runType.runType)


        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table compact>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.common.parameter}</TableHeaderCell>
                            <TableHeaderCell>{t.common.value}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {runType.parameters.map((m, i) => {
                            const hasCustomRenderer = runtypeHandler?.canRenderParameter(m.parameter) && runtypeHandler?.renderParameterLabSettings({
                                parameter: m.parameter, value: m.defaultValue, onChange: v => {
                                    onChange(m, i, v)
                                },
                                labId: this.props.labId
                            }) != null;

                            return (
                                <TableRow key={`${runType.runType}_${m.parameter}`}>
                                    <TableCell>{t.parameter.names[m.parameter]}</TableCell>
                                    <TableCell>
                                        {hasCustomRenderer &&
                                            <FormField>
                                                {runtypeHandler?.renderParameterLabSettings({
                                                    parameter: m.parameter, value: m.defaultValue, onChange: v => {
                                                        onChange(m, i, v)
                                                    },
                                                    labId: this.props.labId
                                                })}
                                            </FormField>}
                                        {!hasCustomRenderer && (m.parameterType === ParameterTypes.Number || m.parameterType === ParameterTypes.Integer) &&
                                            <FormInput name={m.parameter} value={m.defaultValue} onChange={(e, d) => { onChange(m, i, d.value); }} />}
                                        {!hasCustomRenderer && m.parameterType === ParameterTypes.String &&
                                            <FormInput name={m.parameter} value={m.defaultValue} onChange={(e, d) => onChange(m, i, d.value)} />}
                                        {!hasCustomRenderer && m.parameterType === ParameterTypes.Boolean &&
                                            <BPCheckbox name={m.parameter} checked={m.defaultValue === "1"} onChange={(e, d) => onChange(m, i, d.checked)} />}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TabPane>}</TranslationContext.Consumer>);
    };

    private renderParametersPanel() {
        const updateParameterTab = (e, { activeIndex }) => {
            this.setState({ currentParameterTab: activeIndex });
        };

        const parametersTabs = this.state.lab.runTypes.map((t, i) => ({
            menuItem: window.translation.runType[t.runType],
            render: () => this.renderParametersTab(t, i)
        }));
        return (
            <TabPane>
                <Tab menu={{ vertical: true, tabular: true }} panes={parametersTabs} onTabChange={updateParameterTab}
                    activeIndex={this.state.currentParameterTab}>
                </Tab>
            </TabPane>);
    }

    private renderAgenciesPanel() {
        return (
            <TabPane>
                <LabAgenciesViewFC readOnly={true} labId={this.props.labId} />
            </TabPane>
        );
    }

    private renderLabInfoPanel() {
        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <FormInput required name="name" label={t.lab.name} onChange={this.handleInputChange}
                    value={this.state.lab.name} />
                <FormField>
                    <label>{t.lab.timeZone}</label>
                    <TimeZonePicker name="timeZone" value={this.state.lab.timeZone} country={this.state.lab.country}
                        onChange={this.handleZoneChange} />
                </FormField>
                <FormDropdown name="locale" label={t.common.language} onChange={this.handleInputChange} value={this.state.lab.locale} selection options={this.state.localeList} />
                <FormCheckbox name="isDemo" label={t.lab.demoLab} checked={this.state.lab.isDemo} disabled={!this.state.lab.canEditProvisioning} onChange={this.handleInputChange} />
                <FormCheckbox name="isReadOnly" label={t.lab.readOnlyLab} checked={this.state.lab.isReadOnly} disabled={!this.state.lab.canEditProvisioning} onChange={this.handleInputChange} />
                <FormInput name="lowPriorityWorkers" label={t.lab.maximumLowPriority} disabled={!this.state.lab.canEditProvisioning} value={this.state.lab.lowPriorityWorkers} onChange={this.handleInputChange} />
                <FormInput name="dedicatedWorkers" label={t.lab.maximumDedicated} disabled={!this.state.lab.canEditProvisioning} value={this.state.lab.dedicatedWorkers} onChange={this.handleInputChange} />
                <FormInput name="taskSlotsPerNode" label={t.lab.taskSlotsPerNode} disabled={!this.state.lab.canEditProvisioning} value={this.state.lab.taskSlotsPerNode} onChange={this.handleInputChange} />
                <FormInput name="vmSize" label={t.lab.vmSize} disabled={!this.state.lab.canEditProvisioning} value={this.state.lab.vmSize} onChange={this.handleInputChange} />
                <FormTextArea name="autoscaleFormula" label={t.lab.autoscaleFormula} disabled={!this.state.lab.canEditProvisioning} value={this.state.lab.autoscaleFormula ?? ""} onChange={this.handleInputChange} />

                <FormGroup grouped>
                    <label>{t.common.alleleFormat}</label>
                    <FormCheckbox id={`ch_${AlleleFormat.CE_RU}`} name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.CE_RU)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.CE_RU)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`ch_${AlleleFormat.LUS}`} name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.LUS)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.LUS)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`ch_${AlleleFormat.LUSP}`} name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.LUSP)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.LUSP)} onChange={this.handleInputChange} />
                </FormGroup>
                <FormGroup grouped>
                    <label>{'Shared Samples'}</label>
                    {/* <Form.Checkbox id={`sh_${SharingSampleType.None}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.None)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.None)} onChange={this.handleInputChange} /> */}
                    <FormCheckbox id={`sh_${SharingSampleType.All}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.All)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.All)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`sh_${SharingSampleType.Evidence}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.Evidence)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.Evidence)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`sh_${SharingSampleType.Reference}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.Reference)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.Reference)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`sh_${SharingSampleType.ForensicEnrollments}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.ForensicEnrollments)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.ForensicEnrollments)} onChange={this.handleInputChange} />
                    <FormCheckbox id={`sh_${SharingSampleType.QualityCases}`} name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.QualityCases)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.QualityCases)} onChange={this.handleInputChange} />

                </FormGroup>

            </TabPane>
        }</TranslationContext.Consumer>
        );
    }

    private renderReportText() {
        return (
            <TabPane>
                <ReportTextTemplate readOnly={false} labId={this.props.labId} onReportTextTemplateChange={(reportType, value) => {
                    this.setState({ lab: { ...this.state.lab, reportTextTemplate: { ...this.state.lab.reportTextTemplate, [reportType]: value } } })
                }} />
            </TabPane>
        );
    }

    private renderPrintOptions() {
        return (
            <TabPane>
                <LabPrintingOptions readOnly={false} labId={this.props.labId} model={this.state.lab.caseRunPrintingOptions} onChange={values => {
                    // console.log(values)
                    this.setState({ lab: { ...this.state.lab, caseRunPrintingOptions: values } })
                }} />
            </TabPane>
        );
    }

    private handleZoneChange = (e, data) => {
        this.setState({
            lab: {
                ...this.state.lab,
                country: data.country,
                timeZone: data.zone,
            }
        })
    }
}
